/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider } from "@mantine/core";

export default function LawEnforcementCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={4}>Law enforcement</Title>
      <Divider my="md" />
      <Text>
        Under certain circumstances, the Company may be required to disclose
        Your Personal Data if required to do so by law or in response to valid
        requests by public authorities (e.g. a court or a government agency).
      </Text>
    </Card>
  );
}
